export default {
  actionButton: 'Register for a call',
  registerButton: 'Register ',

  palmWelcomeHeadingOne: '声明',
  palmWelcomeHeadingTwo: 'A LIVING STATEMENT',
  palmWelcomeHeadingThree: 'ON SAADIYAT ISLAND',
  palmWelcomeContent:
    'An iconic Japanese-inspired residence, designed by world-renowned architect Koichi Takada, Mamsha Palm is a home that immediately sets itself apart.',

  palmStoryHeading: 'QUIET LUXURY LIVING ON SAADIYAT ISLAND IS UNVEILING SOON',
  palmStoryContent:
    'Designed to connect nature and architecture, every element of Mamsha Palm reflects quiet luxury—from the grand lobby and serene Tea Room to its enviable location in the heart of Saadiyat Cultural District.',
  palmStoryExplore: 'Explore the district',

  palmRegistrationHeading: 'Be the first to know more',
  palmRegistrationContent:
    'Register to speak with our dedicated sales managers about Mamsha Palm, and receive guidance on securing your dream property.',

  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email Address',
  phoneNumber: 'Phone Number',
  reasonToBuy: 'Reason To Buy',
  nationality: 'Nationality',
  residencyStatus: 'Residency Status',
  residencyStatusOptionResident: 'Resident',
  residencyStatusOptionNonResident: 'Non-resident',
  reasonBuyOptionInvestor: 'Invest',
  reasonBuyOptionHomeOwner: 'Live',
  recieveUpdates:
    'Yes, I would like to receive luxury property listings, bespoke advice, and market trend updates.',
  consentLabel: 'I consent to the',
  privacyPolicy: 'Privacy Policy',
  termsAndConditions: 'Terms of Use',
  consentLabelEnd: 'from Aldar',
  footerContactTitle: 'Contact us:',
  launchFooterContactTitle: 'SAY HELLO,',
  footerContactCallText: 'CALL',
  footerContactCallNumber: '800 ALDAR',
  footerContactNumber: '+971 2 810 6400',
  footerContactWebsite: 'Aldar.com',
  developedBy: 'Developed by Aldar Properties',
  successHeading: 'Thank you for signing up',
  successContent:
    "Our dedicated sales managers look forward to speaking with you. Please monitor your inbox for exclusive updates. Intrigued by what else Aldar has to offer? Discover other world-class communities within the heart of Abu Dhabi's Cultural District.",
  successButton: 'Discover more communities',
  PalmFooterContact: 'Contact us:',
  PalmFooterCall: 'CALL 800 ALDAR',
  PalmFooterPhone: '+971 2 810 6400',
  PalmFooterDeveloped: 'Developed by Aldar Properties',

  launchPalmWelcomeHead: 'A LIVING STATEMENT',
  launchPalmWelcomeContent:
    'LIVE IN A ONE-OF-A-KIND RESIDENCE, CRAFTED FOR REFINED BEAUTY',
  launchPalmIntroHeadOne: 'INTRODUCING',
  launchPalmIntroHeadTwo: 'AN ICONIC RESIDENCE',
  launchPalmIntroContent:
    'A Japanese-inspired residence, Mamsha Palm is an architectural icon designed to mimic nature.',
  launchPalmDesignerHeadOne: 'DESIGNED BY',
  launchPalmDesignerHeadTwo: 'KOICHI TAKADA',
  launchPalmDesignerContent:
    'In collaboration with world-renowned architect Koichi Takada, Mamsha Palm is an iconic design that brings nature back into urban environments.',
  launchPalmHarmonyTakeTour: 'Take a Virtual Walk',
  launchPalmHarmonyHeadOne: 'EMBRACING ',
  launchPalmHarmonyHeadTwo: 'NATURE’S HARMONY',
  launchPalmHarmonyContent:
    'Biophilic design weaves throughout Mamsha Palm, inspired by the protective canopy of palm trees that cools their surroundings.',
  launchPalmApartmentsHead: '44 EXCLUSIVE APARTMENTS',
  launchPalmApartmentsContent:
    "Be one of 44 in the world to own a residence or sky villa with spacious layouts that maximise breathtaking views of Guggenheim Abu Dhabi. Close to the heart of Saadiyat Island, it's closer to the beach, shopping, and dining.",
  launchTabAmenity: 'AMENITIES',
  launchTabSustain: 'SUSTAINABILITY',
  launchTabLocation: 'LOCATION',

  launchPalmAmenitiesHead: 'UNMATCHED ELEGANCE AND CONVENIENCE ',
  launchPalmAmenitiesContent:
    'Exclusive amenities designed to elevate your lifestyle. Every serene space combines to weave natural harmony into every moment of life.',

  launchPalmSustainabilityHead: 'CRAFTED FOR SUSTAINABILITY',
  launchPalmSustainabilityContent:
    'Inspired by the natural environment and designed to preserve it, through a series of innovative green technologies and processes.',

  launchPalmLocationHead: 'ON THE MOST FAVOURED ISLAND',
  launchPalmLocationContent:
    'Saadiyat Island seamlessly blends natural beauty and cultural richness, as world-class beaches lie just minutes from globally renowned museums.',

  launchPalmExclusivityHeadOne: 'DETAILS THAT',
  launchPalmExclusivityHeadTwo: 'DEFINE EXCLUSIVITY',
  launchPalmExclusivityContent:
    'Every interior space has been crafted to reflect the refined beauty of Koichi Takada’s architectural concept; materials and finishes all contributing to an elevated way of life.',
  launchPalmFooter: '800 ALDAR  |  ALDAR.COM',
};
